import { SHOP } from '../configs/ApiActionUrl';
import { httpService } from './httpService';
export const shopService = {
    getAll,
    add,
    edit,
    update,
    deleteProduct,
    changeOrder
}

function getAll(){   
    return httpService.get(SHOP.GETALL)
        .then(res => {
            if (res.data) {
                return res.data;
            }
            return res;
        });
}

function add(data){
    return httpService.post(SHOP.ADD, data, {headers: {'Content-Type': 'multipart/form-data'}})
    .then(res => {
        if (res.data) {
            return res.data;
        }
        return res;
    });
}
function edit(id){
    return httpService.get(SHOP.GET_INDIVIDUAL+"/"+id)
        .then(res => {
            if (res.data) {
                return res.data;
            }
            return res;
        });
}
function update(code, data){
    return httpService.put(SHOP.UPDATE_INDIVIDUAL+"/"+code, data, {headers: {'Content-Type': 'multipart/form-data'}})   
    .then(res => {
        if (res.data) {
            return res.data;
        }
        return res;
    });
}
function deleteProduct (code){
    return httpService.delete(SHOP.DELETE+"/"+code, {headers: {'Content-Type': 'multipart/form-data'}}) 
        .then(res => {
            if (res.data) {
                return res.data;
            }
        return res;
    });
}

function changeOrder(code, newRankOrder){
    return httpService.put(SHOP.CHANGE_ORDER+"/rankOrder/"+code, {newRankOrder})   
    .then(res => {
        if (res.data) {
            return res.data;
        }
        return res;
    });
}
